/** @format */

import React, { useState } from "react";
import Header from "../Header/Header"
// import AnalysisDetails from "../AnalysisDetail/AnalysisDetail";
import WeatherCard from "../WeatherCard/WeatherCard";
import WeatherMap from "../WeatherMap/WeatherMap";
// import AnalysisCharts from "../AnalysisChart/AnalysisChart";
import "./Dashboard.css";
import Accessiblity from "../Accessiblity/Accessibility";

const Dashboard = ({ selectedZone,onViewChange }) => {
  const weatherData = {
    SZone: {
      temperature: { value: 33, avg: 27.5, unit: "°C" },
      insolation: { value: 213, avg: 155.4, unit: "W/m²" },
      precipitation: { value: 700, avg: 55.8, unit: "mm" },
      humidity: { value: 65, avg: null, unit: "%" },
    },
    WZone: {
      temperature: { value: 28, avg: 24.2, unit: "°C" },
      insolation: { value: 189, avg: 142.1, unit: "W/m²" },
      precipitation: { value: 850, avg: 68.3, unit: "mm" },
      humidity: { value: 72, avg: null, unit: "%" },
    },
  };
const [currentView, setCurrentView] = useState("dashboard");
  const currentData = weatherData[selectedZone];

  return (
    <div className="dashHeader">
      <Accessiblity/>
      <div className="dashboard">
      <WeatherCard
        title="Temperature"
        value={currentData.temperature.value}
        unit={currentData.temperature.unit}
        average={currentData.temperature.avg}
        color="#ef4444"
      />
      <WeatherCard
        title="Insolation"
        value={currentData.insolation.value}
        unit={currentData.insolation.unit}
        average={currentData.insolation.avg}
        color="#f59e0b"
      />
      <WeatherCard
        title="Precipitation"
        value={currentData.precipitation.value}
        unit={currentData.precipitation.unit}
        average={currentData.precipitation.avg}
        color="#3b82f6"
      />
      <WeatherCard
        title="Humidity"
        value={currentData.humidity.value}
        unit={currentData.humidity.unit}
        color="#10b981"
      />
      <div className="main-content1">
        <div className="content-wrapper1">
        <Header setCurrentView={currentView} onViewChange={setCurrentView} />
          <div className="analysis-container">
            <WeatherMap selectedZone={selectedZone} />
            {/* <AnalysisCharts />
            <AnalysisDetails /> */}
          </div>
        </div>
      </div>
    </div>
    </div>
    
  );
};

export default Dashboard;
